export const itTexts = {
  automationRequests: "Lista Automazioni",
  automationName: "Nome Automazione",
  automationIndex: "",
  automationUserEmail: "Email",
  automationUser: "Utente",
  automationUuid: "UUID",
  automationUserType: "Tipo Utente",
  macAddress: "Mac Address",
  usersRequests: "Lista Utenti",
  userName: "Nome Utente",
  delete_user: "cancella utente",
  installersRequests: "Lista Installatori",
  installerName: "Nome Installatore",
  installerUserEmail: "Email",
  installerUserPhone: "Phone",
  installerUser: "Installatore",
  automation_status_stopped: "fermo",
  automation_status_closed: "chiuso",
  automation_status_opened: "aperto",
  automation_status_moving: "in movimento...",
  eeprom: "eeprom",
  status: "stato",
  delete_automation: "cancella automazione",
  eeprom_error_index: "Indice errore",
  eeprom_maneuver_label: "Manovra",
  eeprom_maneuver_error: "Errore",
  eeprom_maneuver_message: "Messaggio",
  no_message: "messaggio non disponibile",
  no_map: "mappa non disponibile"
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/languages/it.ts